import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Chip,
} from '@mui/material';

const SegmentView = ({ segment, title, color }) => {
  if (!segment) {
    return (
      <Paper sx={{ p: 2, minHeight: 100, bgcolor: 'grey.50' }}>
        <Typography variant="caption" color="text.secondary">
          No segment
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        p: 2,
        minHeight: 100,
        borderLeft: `4px solid ${color}`,
      }}
    >
      {segment.speaker && (
        <Chip
          label={segment.speaker}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ mb: 1 }}
        />
      )}
      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
        {segment.text}
      </Typography>
      {(segment.start !== undefined || segment.end !== undefined) && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {segment.start?.toFixed(1)}s - {segment.end?.toFixed(1)}s
        </Typography>
      )}
    </Paper>
  );
};

const SideBySideView = ({ alignedSegments, transcriptAModel, transcriptBModel }) => {
  if (!alignedSegments || alignedSegments.length === 0) {
    return (
      <Box textAlign="center" p={4}>
        <Typography variant="body1" color="text.secondary">
          No comparison data to display
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Side-by-Side Comparison
      </Typography>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="subtitle1" fontWeight="bold">
              Transcript A
            </Typography>
            {transcriptAModel && (
              <Chip label={transcriptAModel} size="small" color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="subtitle1" fontWeight="bold">
              Transcript B
            </Typography>
            {transcriptBModel && (
              <Chip label={transcriptBModel} size="small" color="secondary" sx={{ ml: 1 }} />
            )}
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          maxHeight: '600px',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
            borderRadius: '4px',
          },
        }}
      >
        {alignedSegments.map((alignedSegment, index) => (
          <Grid container spacing={2} key={index} mb={2}>
            <Grid item xs={12} md={6}>
              <SegmentView
                segment={alignedSegment.segment_a}
                title="Transcript A"
                color="#1976d2"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SegmentView
                segment={alignedSegment.segment_b}
                title="Transcript B"
                color="#9c27b0"
              />
            </Grid>
          </Grid>
        ))}
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
        Showing {alignedSegments.length} aligned segments
      </Typography>
    </Box>
  );
};

export default SideBySideView;
